export interface Keyword {
  id: string;
  language: 'fr' | 'en' | 'es' | 'pt';
  query: string;
  intent: 'commercial' | 'informational' | 'navigational' | 'transactional';
  volume: number;
  kd: number; // Keyword Difficulty (0-100)
  serpFeatures: string[];
  opportunity: number; // Score d'opportunité (0-100)
  cluster: string;
  position?: number;
  url?: string;
  notes?: string;
}

export interface KeywordCluster {
  id: string;
  name: string;
  language: 'fr' | 'en' | 'es' | 'pt';
  keywords: Keyword[];
  priority: 'high' | 'medium' | 'low';
  status: 'to_do' | 'in_progress' | 'done';
  assignee?: string;
}

// Mock data pour Le 39V
export const keywords39V: KeywordCluster[] = [
  // Clusters FR - Gastronomie & Beaux Lieux
  {
    id: 'cluster_fr_1',
    name: 'Restaurant Gastronomique Paris',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_fr_1',
        language: 'fr',
        query: 'restaurant gastronomique paris',
        intent: 'commercial',
        volume: 12800,
        kd: 78,
        serpFeatures: ['Local Pack', 'Reviews', 'Images'],
        opportunity: 92,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_2',
        language: 'fr',
        query: 'restaurant vue tour eiffel',
        intent: 'commercial',
        volume: 8900,
        kd: 72,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 88,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_3',
        language: 'fr',
        query: 'restaurant romantique paris',
        intent: 'transactional',
        volume: 6700,
        kd: 68,
        serpFeatures: ['Local Pack', 'Featured Snippet'],
        opportunity: 85,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_4',
        language: 'fr',
        query: 'diner romantique paris',
        intent: 'transactional',
        volume: 5400,
        kd: 65,
        serpFeatures: ['Images', 'Map Pack'],
        opportunity: 90,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_5',
        language: 'fr',
        query: 'restaurant étoilé paris',
        intent: 'commercial',
        volume: 9200,
        kd: 75,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 87,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_6',
        language: 'fr',
        query: 'restaurant haut de gamme paris',
        intent: 'commercial',
        volume: 4800,
        kd: 70,
        serpFeatures: ['Local Pack'],
        opportunity: 89,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_7',
        language: 'fr',
        query: 'restaurant luxe paris',
        intent: 'commercial',
        volume: 5600,
        kd: 72,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 86,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_8',
        language: 'fr',
        query: 'restaurant rooftop paris',
        intent: 'commercial',
        volume: 7300,
        kd: 68,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 91,
        cluster: 'Restaurant Gastronomique Paris'
      },
      {
        id: 'kw_fr_9',
        language: 'fr',
        query: 'restaurant terrasse vue paris',
        intent: 'commercial',
        volume: 4200,
        kd: 65,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 88,
        cluster: 'Restaurant Gastronomique Paris'
      }
    ]
  },
  {
    id: 'cluster_fr_rooftop',
    name: 'Rooftop & Terrasse Paris',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_fr_roof_1',
        language: 'fr',
        query: 'restaurant rooftop paris',
        intent: 'commercial',
        volume: 7300,
        kd: 68,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 95,
        cluster: 'Rooftop & Terrasse Paris'
      },
      {
        id: 'kw_fr_roof_2',
        language: 'fr',
        query: 'rooftop paris restaurant',
        intent: 'commercial',
        volume: 5400,
        kd: 65,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 93,
        cluster: 'Rooftop & Terrasse Paris'
      },
      {
        id: 'kw_fr_roof_3',
        language: 'fr',
        query: 'meilleur rooftop paris',
        intent: 'commercial',
        volume: 8900,
        kd: 72,
        serpFeatures: ['Featured Snippet', 'Images'],
        opportunity: 92,
        cluster: 'Rooftop & Terrasse Paris'
      },
      {
        id: 'kw_fr_roof_4',
        language: 'fr',
        query: 'rooftop vue tour eiffel',
        intent: 'commercial',
        volume: 6200,
        kd: 70,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 94,
        cluster: 'Rooftop & Terrasse Paris'
      },
      {
        id: 'kw_fr_roof_5',
        language: 'fr',
        query: 'diner rooftop paris',
        intent: 'transactional',
        volume: 4800,
        kd: 66,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 91,
        cluster: 'Rooftop & Terrasse Paris'
      },
      {
        id: 'kw_fr_roof_6',
        language: 'fr',
        query: 'rooftop champs élysées',
        intent: 'commercial',
        volume: 3600,
        kd: 64,
        serpFeatures: ['Images'],
        opportunity: 89,
        cluster: 'Rooftop & Terrasse Paris'
      },
      {
        id: 'kw_fr_roof_7',
        language: 'fr',
        query: 'restaurant terrasse vue paris',
        intent: 'commercial',
        volume: 4200,
        kd: 65,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 90,
        cluster: 'Rooftop & Terrasse Paris'
      },
      {
        id: 'kw_fr_roof_8',
        language: 'fr',
        query: 'rooftop gastronomique paris',
        intent: 'commercial',
        volume: 2400,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Rooftop & Terrasse Paris'
      }
    ]
  },
  {
    id: 'cluster_fr_vue',
    name: 'Restaurant avec Vue Paris',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_fr_vue_1',
        language: 'fr',
        query: 'restaurant avec vue panoramique paris',
        intent: 'commercial',
        volume: 3800,
        kd: 67,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 90,
        cluster: 'Restaurant avec Vue Paris'
      },
      {
        id: 'kw_fr_vue_2',
        language: 'fr',
        query: 'diner vue paris',
        intent: 'transactional',
        volume: 4500,
        kd: 64,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Restaurant avec Vue Paris'
      },
      {
        id: 'kw_fr_vue_3',
        language: 'fr',
        query: 'restaurant vue arc de triomphe',
        intent: 'commercial',
        volume: 2100,
        kd: 58,
        serpFeatures: ['Images'],
        opportunity: 85,
        cluster: 'Restaurant avec Vue Paris'
      },
      {
        id: 'kw_fr_vue_4',
        language: 'fr',
        query: 'restaurant vue champs elysées',
        intent: 'commercial',
        volume: 3200,
        kd: 62,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 87,
        cluster: 'Restaurant avec Vue Paris'
      },
      {
        id: 'kw_fr_vue_5',
        language: 'fr',
        query: 'restaurant panoramique paris',
        intent: 'commercial',
        volume: 2800,
        kd: 60,
        serpFeatures: ['Images'],
        opportunity: 86,
        cluster: 'Restaurant avec Vue Paris'
      }
    ]
  },
  {
    id: 'cluster_fr_2',
    name: 'Privatisation & Événements',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_fr_priv_1',
        language: 'fr',
        query: 'privatisation restaurant paris',
        intent: 'commercial',
        volume: 3200,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 95,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_2',
        language: 'fr',
        query: 'restaurant privatisable paris',
        intent: 'commercial',
        volume: 2800,
        kd: 55,
        serpFeatures: ['Featured Snippet'],
        opportunity: 93,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_3',
        language: 'fr',
        query: 'seminaire restaurant paris',
        intent: 'commercial',
        volume: 1900,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_4',
        language: 'fr',
        query: 'privatisation restaurant gastronomique',
        intent: 'commercial',
        volume: 1500,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 91,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_5',
        language: 'fr',
        query: 'restaurant privatisation soirée entreprise',
        intent: 'commercial',
        volume: 1200,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 89,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_6',
        language: 'fr',
        query: 'événement entreprise restaurant paris',
        intent: 'commercial',
        volume: 2100,
        kd: 50,
        serpFeatures: ['Local Pack'],
        opportunity: 90,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_7',
        language: 'fr',
        query: 'privatiser restaurant paris',
        intent: 'commercial',
        volume: 1800,
        kd: 54,
        serpFeatures: ['Featured Snippet'],
        opportunity: 87,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_8',
        language: 'fr',
        query: 'location salle restaurant paris',
        intent: 'commercial',
        volume: 2400,
        kd: 56,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_9',
        language: 'fr',
        query: 'restaurant privatisation anniversaire',
        intent: 'commercial',
        volume: 1600,
        kd: 45,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Privatisation & Événements'
      },
      {
        id: 'kw_fr_priv_10',
        language: 'fr',
        query: 'privatisation restaurant mariage paris',
        intent: 'commercial',
        volume: 1400,
        kd: 50,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 89,
        cluster: 'Privatisation & Événements'
      }
    ]
  },
  {
    id: 'cluster_fr_groupe',
    name: 'Repas de Groupe & Séminaires',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_fr_grp_1',
        language: 'fr',
        query: 'restaurant groupe paris',
        intent: 'commercial',
        volume: 4200,
        kd: 62,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 92,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_2',
        language: 'fr',
        query: 'repas de groupe paris',
        intent: 'commercial',
        volume: 3600,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 90,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_3',
        language: 'fr',
        query: 'restaurant pour groupe paris',
        intent: 'commercial',
        volume: 2800,
        kd: 55,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_4',
        language: 'fr',
        query: 'diner de groupe paris',
        intent: 'transactional',
        volume: 2200,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_5',
        language: 'fr',
        query: 'restaurant séminaire paris',
        intent: 'commercial',
        volume: 2600,
        kd: 54,
        serpFeatures: ['Local Pack'],
        opportunity: 89,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_6',
        language: 'fr',
        query: 'restaurant team building paris',
        intent: 'commercial',
        volume: 1800,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_7',
        language: 'fr',
        query: 'repas entreprise paris',
        intent: 'commercial',
        volume: 3200,
        kd: 56,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_8',
        language: 'fr',
        query: 'restaurant réception paris',
        intent: 'commercial',
        volume: 2400,
        kd: 53,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 87,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_9',
        language: 'fr',
        query: 'déjeuner affaires paris',
        intent: 'commercial',
        volume: 2900,
        kd: 57,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Repas de Groupe & Séminaires'
      },
      {
        id: 'kw_fr_grp_10',
        language: 'fr',
        query: 'restaurant banquet paris',
        intent: 'commercial',
        volume: 1500,
        kd: 50,
        serpFeatures: ['Local Pack'],
        opportunity: 84,
        cluster: 'Repas de Groupe & Séminaires'
      }
    ]
  },
  {
    id: 'cluster_fr_occas',
    name: 'Occasions Spéciales',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_fr_occ_1',
        language: 'fr',
        query: 'restaurant demande en mariage paris',
        intent: 'transactional',
        volume: 1800,
        kd: 45,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 93,
        cluster: 'Occasions Spéciales'
      },
      {
        id: 'kw_fr_occ_2',
        language: 'fr',
        query: 'restaurant anniversaire paris',
        intent: 'transactional',
        volume: 4200,
        kd: 60,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 88,
        cluster: 'Occasions Spéciales'
      },
      {
        id: 'kw_fr_occ_3',
        language: 'fr',
        query: 'restaurant saint valentin paris',
        intent: 'transactional',
        volume: 5600,
        kd: 65,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 91,
        cluster: 'Occasions Spéciales'
      },
      {
        id: 'kw_fr_occ_4',
        language: 'fr',
        query: 'restaurant fiançailles paris',
        intent: 'transactional',
        volume: 1200,
        kd: 42,
        serpFeatures: ['Local Pack'],
        opportunity: 89,
        cluster: 'Occasions Spéciales'
      },
      {
        id: 'kw_fr_occ_5',
        language: 'fr',
        query: 'restaurant anniversaire mariage paris',
        intent: 'commercial',
        volume: 1600,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Occasions Spéciales'
      },
      {
        id: 'kw_fr_occ_6',
        language: 'fr',
        query: 'diner romantique exceptionnel paris',
        intent: 'transactional',
        volume: 2100,
        kd: 52,
        serpFeatures: ['Images'],
        opportunity: 90,
        cluster: 'Occasions Spéciales'
      },
      {
        id: 'kw_fr_occ_7',
        language: 'fr',
        query: 'restaurant sortie exceptionnelle paris',
        intent: 'commercial',
        volume: 1400,
        kd: 46,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Occasions Spéciales'
      }
    ]
  },
  
  // Clusters EN
  {
    id: 'cluster_en_1',
    name: 'Fine Dining Experience',
    language: 'en',
    priority: 'high',
    status: 'in_progress',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_en_1',
        language: 'en',
        query: 'best fine dining restaurants paris',
        intent: 'commercial',
        volume: 12000,
        kd: 68,
        serpFeatures: ['Local Pack', 'Reviews', 'Images'],
        opportunity: 85,
        cluster: 'Fine Dining Experience',
        position: 8
      },
      {
        id: 'kw_en_2',
        language: 'en',
        query: 'michelin star restaurants paris',
        intent: 'commercial',
        volume: 8900,
        kd: 72,
        serpFeatures: ['Local Pack', 'Rich Snippets'],
        opportunity: 78,
        cluster: 'Fine Dining Experience',
        position: 12
      },
      {
        id: 'kw_en_3',
        language: 'en',
        query: 'luxury dining paris with view',
        intent: 'commercial',
        volume: 4500,
        kd: 55,
        serpFeatures: ['Images', 'Map Pack'],
        opportunity: 92,
        cluster: 'Fine Dining Experience',
        position: 5
      },
      {
        id: 'kw_en_4',
        language: 'en',
        query: 'restaurant near eiffel tower',
        intent: 'commercial',
        volume: 15600,
        kd: 75,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 95,
        cluster: 'Fine Dining Experience'
      },
      {
        id: 'kw_en_5',
        language: 'en',
        query: 'fine dining with eiffel tower view',
        intent: 'commercial',
        volume: 3800,
        kd: 62,
        serpFeatures: ['Images', 'Reviews'],
        opportunity: 90,
        cluster: 'Fine Dining Experience'
      },
      {
        id: 'kw_en_6',
        language: 'en',
        query: 'best rooftop restaurants paris',
        intent: 'informational',
        volume: 7200,
        kd: 68,
        serpFeatures: ['Featured Snippet', 'Images'],
        opportunity: 95,
        cluster: 'Fine Dining Experience'
      },
      {
        id: 'kw_en_7',
        language: 'en',
        query: 'rooftop restaurant paris eiffel tower',
        intent: 'commercial',
        volume: 5800,
        kd: 66,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 94,
        cluster: 'Fine Dining Experience'
      },
      {
        id: 'kw_en_8',
        language: 'en',
        query: 'paris rooftop dining',
        intent: 'commercial',
        volume: 4600,
        kd: 64,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 92,
        cluster: 'Fine Dining Experience'
      },
      {
        id: 'kw_en_9',
        language: 'en',
        query: 'rooftop dinner paris',
        intent: 'transactional',
        volume: 3900,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 91,
        cluster: 'Fine Dining Experience'
      }
    ]
  },
  {
    id: 'cluster_en_2',
    name: 'Special Occasions',
    language: 'en',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_en_7',
        language: 'en',
        query: 'romantic dinner paris restaurant',
        intent: 'transactional',
        volume: 8900,
        kd: 62,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 93,
        cluster: 'Special Occasions'
      },
      {
        id: 'kw_en_8',
        language: 'en',
        query: 'anniversary dinner paris',
        intent: 'transactional',
        volume: 3200,
        kd: 58,
        serpFeatures: ['Featured Snippet', 'Images'],
        opportunity: 88,
        cluster: 'Special Occasions'
      },
      {
        id: 'kw_en_9',
        language: 'en',
        query: 'proposal restaurant paris',
        intent: 'transactional',
        volume: 2400,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 91,
        cluster: 'Special Occasions'
      },
      {
        id: 'kw_en_10',
        language: 'en',
        query: 'birthday dinner paris',
        intent: 'transactional',
        volume: 1800,
        kd: 48,
        serpFeatures: ['Images'],
        opportunity: 85,
        cluster: 'Special Occasions'
      }
    ]
  },
  {
    id: 'cluster_en_3',
    name: 'Business & Corporate',
    language: 'en',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_en_11',
        language: 'en',
        query: 'private dining paris',
        intent: 'commercial',
        volume: 4200,
        kd: 58,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 94,
        cluster: 'Business & Corporate'
      },
      {
        id: 'kw_en_12',
        language: 'en',
        query: 'corporate event venue paris',
        intent: 'commercial',
        volume: 3600,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 90,
        cluster: 'Business & Corporate'
      },
      {
        id: 'kw_en_13',
        language: 'en',
        query: 'business lunch paris',
        intent: 'commercial',
        volume: 5400,
        kd: 65,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 82,
        cluster: 'Business & Corporate'
      },
      {
        id: 'kw_en_14',
        language: 'en',
        query: 'corporate dinner paris',
        intent: 'commercial',
        volume: 3200,
        kd: 60,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Business & Corporate'
      },
      {
        id: 'kw_en_15',
        language: 'en',
        query: 'team building restaurant paris',
        intent: 'commercial',
        volume: 2400,
        kd: 54,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Business & Corporate'
      },
      {
        id: 'kw_en_16',
        language: 'en',
        query: 'company event paris restaurant',
        intent: 'commercial',
        volume: 2800,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Business & Corporate'
      },
      {
        id: 'kw_en_17',
        language: 'en',
        query: 'business meeting restaurant paris',
        intent: 'commercial',
        volume: 1900,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Business & Corporate'
      },
      {
        id: 'kw_en_18',
        language: 'en',
        query: 'executive dining paris',
        intent: 'commercial',
        volume: 1600,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 84,
        cluster: 'Business & Corporate'
      }
    ]
  },
  {
    id: 'cluster_en_group',
    name: 'Group Dining & Events',
    language: 'en',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_en_grp_1',
        language: 'en',
        query: 'group dining paris',
        intent: 'commercial',
        volume: 3400,
        kd: 56,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 90,
        cluster: 'Group Dining & Events'
      },
      {
        id: 'kw_en_grp_2',
        language: 'en',
        query: 'restaurant for groups paris',
        intent: 'commercial',
        volume: 2900,
        kd: 54,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Group Dining & Events'
      },
      {
        id: 'kw_en_grp_3',
        language: 'en',
        query: 'large group restaurant paris',
        intent: 'commercial',
        volume: 2200,
        kd: 50,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Group Dining & Events'
      },
      {
        id: 'kw_en_grp_4',
        language: 'en',
        query: 'party venue paris restaurant',
        intent: 'commercial',
        volume: 2600,
        kd: 52,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 87,
        cluster: 'Group Dining & Events'
      },
      {
        id: 'kw_en_grp_5',
        language: 'en',
        query: 'banquet hall paris',
        intent: 'commercial',
        volume: 1800,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 84,
        cluster: 'Group Dining & Events'
      },
      {
        id: 'kw_en_grp_6',
        language: 'en',
        query: 'event space restaurant paris',
        intent: 'commercial',
        volume: 2100,
        kd: 51,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Group Dining & Events'
      },
      {
        id: 'kw_en_grp_7',
        language: 'en',
        query: 'group celebration paris',
        intent: 'commercial',
        volume: 1500,
        kd: 45,
        serpFeatures: ['Local Pack'],
        opportunity: 83,
        cluster: 'Group Dining & Events'
      }
    ]
  },
  {
    id: 'cluster_en_private',
    name: 'Private Events & Buyouts',
    language: 'en',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_en_priv_1',
        language: 'en',
        query: 'restaurant buyout paris',
        intent: 'commercial',
        volume: 1200,
        kd: 42,
        serpFeatures: ['Local Pack'],
        opportunity: 91,
        cluster: 'Private Events & Buyouts'
      },
      {
        id: 'kw_en_priv_2',
        language: 'en',
        query: 'private event space paris',
        intent: 'commercial',
        volume: 2400,
        kd: 55,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 89,
        cluster: 'Private Events & Buyouts'
      },
      {
        id: 'kw_en_priv_3',
        language: 'en',
        query: 'exclusive restaurant paris',
        intent: 'commercial',
        volume: 1800,
        kd: 50,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Private Events & Buyouts'
      },
      {
        id: 'kw_en_priv_4',
        language: 'en',
        query: 'private party restaurant paris',
        intent: 'commercial',
        volume: 2100,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Private Events & Buyouts'
      },
      {
        id: 'kw_en_priv_5',
        language: 'en',
        query: 'restaurant private room paris',
        intent: 'commercial',
        volume: 2800,
        kd: 58,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 86,
        cluster: 'Private Events & Buyouts'
      },
      {
        id: 'kw_en_priv_6',
        language: 'en',
        query: 'venue hire paris restaurant',
        intent: 'commercial',
        volume: 1400,
        kd: 46,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Private Events & Buyouts'
      }
    ]
  },
  {
    id: 'cluster_en_luxury',
    name: 'Luxury & Premium Venues',
    language: 'en',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_en_lux_1',
        language: 'en',
        query: 'luxury restaurant paris with view',
        intent: 'commercial',
        volume: 3600,
        kd: 65,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 92,
        cluster: 'Luxury & Premium Venues'
      },
      {
        id: 'kw_en_lux_2',
        language: 'en',
        query: 'upscale dining paris',
        intent: 'commercial',
        volume: 2800,
        kd: 60,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 89,
        cluster: 'Luxury & Premium Venues'
      },
      {
        id: 'kw_en_lux_3',
        language: 'en',
        query: 'high end restaurant paris',
        intent: 'commercial',
        volume: 3200,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Luxury & Premium Venues'
      },
      {
        id: 'kw_en_lux_4',
        language: 'en',
        query: 'gourmet restaurant paris',
        intent: 'commercial',
        volume: 4200,
        kd: 68,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 87,
        cluster: 'Luxury & Premium Venues'
      },
      {
        id: 'kw_en_lux_5',
        language: 'en',
        query: 'elegant restaurant paris',
        intent: 'commercial',
        volume: 2400,
        kd: 56,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Luxury & Premium Venues'
      },
      {
        id: 'kw_en_lux_6',
        language: 'en',
        query: 'fancy restaurant paris',
        intent: 'commercial',
        volume: 5100,
        kd: 70,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 85,
        cluster: 'Luxury & Premium Venues'
      }
    ]
  },

  // Clusters ES
  {
    id: 'cluster_es_1',
    name: 'Restaurantes de Lujo',
    language: 'es',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_es_1',
        language: 'es',
        query: 'mejores restaurantes paris',
        intent: 'commercial',
        volume: 5400,
        kd: 65,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 88,
        cluster: 'Restaurantes de Lujo'
      },
      {
        id: 'kw_es_2',
        language: 'es',
        query: 'restaurantes estrellas michelin paris',
        intent: 'informational',
        volume: 2800,
        kd: 58,
        serpFeatures: ['Featured Snippet'],
        opportunity: 72,
        cluster: 'Restaurantes de Lujo'
      }
    ]
  },
  {
    id: 'cluster_es_2',
    name: 'Experiencias Gastronómicas',
    language: 'es',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_es_3',
        language: 'es',
        query: 'cena romántica paris restaurante',
        intent: 'transactional',
        volume: 4200,
        kd: 52,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 90,
        cluster: 'Experiencias Gastronómicas'
      },
      {
        id: 'kw_es_4',
        language: 'es',
        query: 'restaurante con vista torre eiffel',
        intent: 'commercial',
        volume: 3600,
        kd: 58,
        serpFeatures: ['Images', 'Map Pack'],
        opportunity: 92,
        cluster: 'Experiencias Gastronómicas'
      },
      {
        id: 'kw_es_5',
        language: 'es',
        query: 'restaurantes romanticos paris',
        intent: 'commercial',
        volume: 2800,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Experiencias Gastronómicas'
      },
      {
        id: 'kw_es_6',
        language: 'es',
        query: 'donde cenar en paris',
        intent: 'informational',
        volume: 6200,
        kd: 62,
        serpFeatures: ['Featured Snippet', 'Images'],
        opportunity: 85,
        cluster: 'Experiencias Gastronómicas'
      },
      {
        id: 'kw_es_7',
        language: 'es',
        query: 'restaurante rooftop paris',
        intent: 'commercial',
        volume: 3400,
        kd: 58,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 92,
        cluster: 'Experiencias Gastronómicas'
      },
      {
        id: 'kw_es_8',
        language: 'es',
        query: 'terraza vista torre eiffel',
        intent: 'commercial',
        volume: 2800,
        kd: 56,
        serpFeatures: ['Images'],
        opportunity: 90,
        cluster: 'Experiencias Gastronómicas'
      }
    ]
  },
  {
    id: 'cluster_es_3',
    name: 'Eventos Corporativos',
    language: 'es',
    priority: 'medium',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_es_7',
        language: 'es',
        query: 'restaurante privado paris',
        intent: 'commercial',
        volume: 1800,
        kd: 45,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Eventos Corporativos'
      },
      {
        id: 'kw_es_8',
        language: 'es',
        query: 'eventos corporativos paris',
        intent: 'commercial',
        volume: 1200,
        kd: 42,
        serpFeatures: ['Local Pack'],
        opportunity: 83,
        cluster: 'Eventos Corporativos'
      }
    ]
  },

  // Clusters PT
  {
    id: 'cluster_pt_1',
    name: 'Restaurantes de Luxo',
    language: 'pt',
    priority: 'high',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_pt_1',
        language: 'pt',
        query: 'melhores restaurantes paris',
        intent: 'commercial',
        volume: 3200,
        kd: 62,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 88,
        cluster: 'Restaurantes de Luxo'
      },
      {
        id: 'kw_pt_2',
        language: 'pt',
        query: 'restaurantes estrela michelin paris',
        intent: 'informational',
        volume: 1500,
        kd: 55,
        serpFeatures: ['Featured Snippet'],
        opportunity: 82,
        cluster: 'Restaurantes de Luxo'
      },
      {
        id: 'kw_pt_3',
        language: 'pt',
        query: 'jantar romantico paris',
        intent: 'transactional',
        volume: 2400,
        kd: 48,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 90,
        cluster: 'Restaurantes de Luxo'
      },
      {
        id: 'kw_pt_4',
        language: 'pt',
        query: 'restaurante com vista torre eiffel',
        intent: 'commercial',
        volume: 1800,
        kd: 52,
        serpFeatures: ['Images'],
        opportunity: 87,
        cluster: 'Restaurantes de Luxo'
      },
      {
        id: 'kw_pt_5',
        language: 'pt',
        query: 'onde jantar em paris',
        intent: 'informational',
        volume: 4500,
        kd: 58,
        serpFeatures: ['Featured Snippet'],
        opportunity: 85,
        cluster: 'Restaurantes de Luxo'
      },
      {
        id: 'kw_pt_6',
        language: 'pt',
        query: 'restaurante rooftop paris',
        intent: 'commercial',
        volume: 1800,
        kd: 52,
        serpFeatures: ['Images', 'Local Pack'],
        opportunity: 88,
        cluster: 'Restaurantes de Luxo'
      },
      {
        id: 'kw_pt_7',
        language: 'pt',
        query: 'rooftop vista torre eiffel',
        intent: 'commercial',
        volume: 1400,
        kd: 50,
        serpFeatures: ['Images'],
        opportunity: 87,
        cluster: 'Restaurantes de Luxo'
      }
    ]
  },
  {
    id: 'cluster_pt_2',
    name: 'Gastronomia Francesa',
    language: 'pt',
    priority: 'medium',
    status: 'to_do',
    keywords: [
      {
        id: 'kw_pt_6',
        language: 'pt',
        query: 'restaurante frances paris',
        intent: 'commercial',
        volume: 2200,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 84,
        cluster: 'Gastronomia Francesa'
      },
      {
        id: 'kw_pt_7',
        language: 'pt',
        query: 'culinaria francesa paris',
        intent: 'informational',
        volume: 1200,
        kd: 42,
        serpFeatures: ['Images'],
        opportunity: 80,
        cluster: 'Gastronomia Francesa'
      },
      {
        id: 'kw_pt_8',
        language: 'pt',
        query: 'experiencia gastronomica paris',
        intent: 'commercial',
        volume: 1500,
        kd: 45,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Gastronomia Francesa'
      }
    ]
  }
];

// Mock data pour Café Max - Données réelles SEMrush
export const keywordsCafeMax: KeywordCluster[] = [
  // Cluster 1 : Marque (Très important - seuls mots-clés bien positionnés)
  {
    id: 'cluster_cm_marque',
    name: 'Mots-clés de marque',
    language: 'fr',
    priority: 'high',
    status: 'done',
    assignee: 'SEO Team',
    keywords: [
      {
        id: 'kw_cm_1',
        language: 'fr',
        query: 'café max',
        intent: 'navigational',
        volume: 880,
        kd: 25,
        position: 10,
        url: 'https://cafemax.fr/',
        serpFeatures: ['Local Pack', 'Knowledge Panel'],
        opportunity: 95,
        cluster: 'Mots-clés de marque',
        notes: 'Position 10 - Données SEMrush réelles'
      },
      {
        id: 'kw_cm_2',
        language: 'fr',
        query: 'cafe max invalides',
        intent: 'navigational',
        volume: 320,
        kd: 20,
        position: 20,
        url: 'https://cafemax.fr/',
        serpFeatures: ['Local Pack'],
        opportunity: 92,
        cluster: 'Mots-clés de marque'
      },
      {
        id: 'kw_cm_3',
        language: 'fr',
        query: 'max cafes',
        intent: 'navigational',
        volume: 210,
        kd: 18,
        position: 1,
        url: 'https://cafemax.fr/',
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 98,
        cluster: 'Mots-clés de marque',
        notes: 'TOP 3 - Excellent positionnement'
      },
      {
        id: 'kw_cm_4',
        language: 'fr',
        query: 'café mäx',
        intent: 'navigational',
        volume: 180,
        kd: 22,
        position: 10,
        url: 'https://cafemax.fr/',
        serpFeatures: ['Local Pack'],
        opportunity: 90,
        cluster: 'Mots-clés de marque'
      },
      {
        id: 'kw_cm_5',
        language: 'fr',
        query: 'photos de café max invalides',
        intent: 'informational',
        volume: 90,
        kd: 15,
        position: 20,
        url: 'https://cafemax.fr/',
        serpFeatures: ['Images'],
        opportunity: 85,
        cluster: 'Mots-clés de marque'
      },
      {
        id: 'kw_cm_6',
        language: 'fr',
        query: 'cafeteria max',
        intent: 'navigational',
        volume: 150,
        kd: 20,
        position: 20,
        url: 'https://cafemax.fr/',
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Mots-clés de marque'
      },
      {
        id: 'kw_cm_7',
        language: 'fr',
        query: 'max cafe',
        intent: 'navigational',
        volume: 260,
        kd: 28,
        position: 20,
        url: 'https://cafemax.fr/',
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Mots-clés de marque'
      },
      {
        id: 'kw_cm_8',
        language: 'fr',
        query: 'café de max',
        intent: 'navigational',
        volume: 120,
        kd: 18,
        position: 30,
        url: 'https://cafemax.fr/',
        serpFeatures: [],
        opportunity: 82,
        cluster: 'Mots-clés de marque'
      }
    ]
  },
  // Cluster 2 : Bistrot Invalides (PRIORITÉ - Non positionné!)
  {
    id: 'cluster_cm_invalides',
    name: 'Bistrot & Restaurant Invalides',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_inv_1',
        language: 'fr',
        query: 'bistrot invalides',
        intent: 'commercial',
        volume: 1200,
        kd: 65,
        serpFeatures: ['Local Pack', 'Images', 'Reviews'],
        opportunity: 95,
        cluster: 'Bistrot & Restaurant Invalides',
        notes: 'NON POSITIONNÉ - Opportunité CRITIQUE'
      },
      {
        id: 'kw_cm_inv_2',
        language: 'fr',
        query: 'restaurant invalides',
        intent: 'commercial',
        volume: 2800,
        kd: 70,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 93,
        cluster: 'Bistrot & Restaurant Invalides',
        notes: 'NON POSITIONNÉ - Volume très élevé'
      },
      {
        id: 'kw_cm_inv_3',
        language: 'fr',
        query: 'bistrot traditionnel invalides',
        intent: 'commercial',
        volume: 480,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Bistrot & Restaurant Invalides'
      },
      {
        id: 'kw_cm_inv_4',
        language: 'fr',
        query: 'restaurant français invalides',
        intent: 'commercial',
        volume: 920,
        kd: 62,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 90,
        cluster: 'Bistrot & Restaurant Invalides'
      },
      {
        id: 'kw_cm_inv_5',
        language: 'fr',
        query: 'où manger aux invalides',
        intent: 'commercial',
        volume: 780,
        kd: 55,
        serpFeatures: ['Featured Snippet', 'Local Pack'],
        opportunity: 92,
        cluster: 'Bistrot & Restaurant Invalides'
      },
      {
        id: 'kw_cm_inv_6',
        language: 'fr',
        query: 'restaurant près des invalides',
        intent: 'commercial',
        volume: 1500,
        kd: 68,
        serpFeatures: ['Local Pack', 'Map'],
        opportunity: 91,
        cluster: 'Bistrot & Restaurant Invalides'
      },
      {
        id: 'kw_cm_inv_7',
        language: 'fr',
        query: 'bistrot motte picquet',
        intent: 'commercial',
        volume: 320,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Bistrot & Restaurant Invalides'
      }
    ]
  },
  // Cluster 3 : Restaurant 7ème arrondissement
  {
    id: 'cluster_cm_7eme',
    name: 'Restaurant Paris 7ème',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_7_1',
        language: 'fr',
        query: 'restaurant 7ème',
        intent: 'commercial',
        volume: 3200,
        kd: 75,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 94,
        cluster: 'Restaurant Paris 7ème',
        notes: 'NON POSITIONNÉ - Volume très élevé'
      },
      {
        id: 'kw_cm_7_2',
        language: 'fr',
        query: 'restaurant 7ème arrondissement',
        intent: 'commercial',
        volume: 2100,
        kd: 72,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 92,
        cluster: 'Restaurant Paris 7ème'
      },
      {
        id: 'kw_cm_7_3',
        language: 'fr',
        query: 'bistrot paris 7',
        intent: 'commercial',
        volume: 890,
        kd: 65,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 89,
        cluster: 'Restaurant Paris 7ème'
      },
      {
        id: 'kw_cm_7_4',
        language: 'fr',
        query: 'restaurant traditionnel 7ème',
        intent: 'commercial',
        volume: 680,
        kd: 60,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Restaurant Paris 7ème'
      },
      {
        id: 'kw_cm_7_5',
        language: 'fr',
        query: 'brasserie 7ème',
        intent: 'commercial',
        volume: 540,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Restaurant Paris 7ème'
      },
      {
        id: 'kw_cm_7_6',
        language: 'fr',
        query: 'meilleur restaurant 7ème',
        intent: 'commercial',
        volume: 1100,
        kd: 70,
        serpFeatures: ['Featured Snippet', 'Local Pack'],
        opportunity: 90,
        cluster: 'Restaurant Paris 7ème'
      }
    ]
  },
  // Cluster 4 : Déjeuner & Terrasse
  {
    id: 'cluster_cm_dejeuner',
    name: 'Déjeuner & Terrasse',
    language: 'fr',
    priority: 'high',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_dej_1',
        language: 'fr',
        query: 'déjeuner invalides',
        intent: 'transactional',
        volume: 720,
        kd: 55,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Déjeuner & Terrasse'
      },
      {
        id: 'kw_cm_dej_2',
        language: 'fr',
        query: 'restaurant midi invalides',
        intent: 'transactional',
        volume: 480,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Déjeuner & Terrasse'
      },
      {
        id: 'kw_cm_dej_3',
        language: 'fr',
        query: 'déjeuner affaires invalides',
        intent: 'commercial',
        volume: 320,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Déjeuner & Terrasse'
      },
      {
        id: 'kw_cm_dej_4',
        language: 'fr',
        query: 'restaurant terrasse invalides',
        intent: 'commercial',
        volume: 940,
        kd: 60,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 90,
        cluster: 'Déjeuner & Terrasse'
      },
      {
        id: 'kw_cm_dej_5',
        language: 'fr',
        query: 'terrasse 7ème',
        intent: 'commercial',
        volume: 820,
        kd: 58,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 87,
        cluster: 'Déjeuner & Terrasse'
      },
      {
        id: 'kw_cm_dej_6',
        language: 'fr',
        query: 'restaurant terrasse paris 7',
        intent: 'commercial',
        volume: 650,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Déjeuner & Terrasse'
      }
    ]
  },
  // Cluster 5 : Historique & Patrimoine (STORY UNIQUE)
  {
    id: 'cluster_cm_histoire',
    name: 'Bistrot Historique & Résistance',
    language: 'fr',
    priority: 'medium',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_hist_1',
        language: 'fr',
        query: 'restaurant historique paris',
        intent: 'informational',
        volume: 1200,
        kd: 68,
        serpFeatures: ['Featured Snippet', 'Images'],
        opportunity: 92,
        cluster: 'Bistrot Historique & Résistance',
        notes: 'OPPORTUNITÉ UNIQUE - Histoire Jean Moulin'
      },
      {
        id: 'kw_cm_hist_2',
        language: 'fr',
        query: 'bistrot résistance paris',
        intent: 'informational',
        volume: 180,
        kd: 45,
        serpFeatures: ['Featured Snippet'],
        opportunity: 88,
        cluster: 'Bistrot Historique & Résistance',
        notes: 'Niche très spécifique - Story unique'
      },
      {
        id: 'kw_cm_hist_3',
        language: 'fr',
        query: 'restaurant jean moulin paris',
        intent: 'informational',
        volume: 90,
        kd: 42,
        serpFeatures: [],
        opportunity: 85,
        cluster: 'Bistrot Historique & Résistance'
      },
      {
        id: 'kw_cm_hist_4',
        language: 'fr',
        query: 'lieux résistance paris',
        intent: 'informational',
        volume: 420,
        kd: 55,
        serpFeatures: ['Featured Snippet', 'People Also Ask'],
        opportunity: 80,
        cluster: 'Bistrot Historique & Résistance'
      },
      {
        id: 'kw_cm_hist_5',
        language: 'fr',
        query: 'restaurant belle époque paris',
        intent: 'commercial',
        volume: 380,
        kd: 58,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 82,
        cluster: 'Bistrot Historique & Résistance'
      },
      {
        id: 'kw_cm_hist_6',
        language: 'fr',
        query: 'bistrot authentique paris',
        intent: 'commercial',
        volume: 920,
        kd: 65,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Bistrot Historique & Résistance'
      }
    ]
  },
  // Cluster 6 : Cuisine Traditionnelle & Chef
  {
    id: 'cluster_cm_cuisine',
    name: 'Cuisine Traditionnelle Française',
    language: 'fr',
    priority: 'medium',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_cuis_1',
        language: 'fr',
        query: 'cuisine française traditionnelle paris',
        intent: 'commercial',
        volume: 1800,
        kd: 72,
        serpFeatures: ['Local Pack', 'Featured Snippet'],
        opportunity: 90,
        cluster: 'Cuisine Traditionnelle Française'
      },
      {
        id: 'kw_cm_cuis_2',
        language: 'fr',
        query: 'restaurant frédéric vardon',
        intent: 'navigational',
        volume: 210,
        kd: 35,
        serpFeatures: ['Knowledge Panel'],
        opportunity: 95,
        cluster: 'Cuisine Traditionnelle Française',
        notes: 'Chef connu - opportunité de positionnement'
      },
      {
        id: 'kw_cm_cuis_3',
        language: 'fr',
        query: 'bistrot canaille paris',
        intent: 'commercial',
        volume: 520,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Cuisine Traditionnelle Française'
      },
      {
        id: 'kw_cm_cuis_4',
        language: 'fr',
        query: 'plats traditionnels français',
        intent: 'informational',
        volume: 2400,
        kd: 60,
        serpFeatures: ['Featured Snippet', 'People Also Ask'],
        opportunity: 75,
        cluster: 'Cuisine Traditionnelle Française',
        notes: 'Contenu blog opportunité'
      },
      {
        id: 'kw_cm_cuis_5',
        language: 'fr',
        query: 'cuisine de saison paris',
        intent: 'commercial',
        volume: 680,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Cuisine Traditionnelle Française'
      },
      {
        id: 'kw_cm_cuis_6',
        language: 'fr',
        query: 'restaurant produits frais paris',
        intent: 'commercial',
        volume: 540,
        kd: 60,
        serpFeatures: ['Local Pack'],
        opportunity: 83,
        cluster: 'Cuisine Traditionnelle Française'
      }
    ]
  },
  // Cluster 7 : Tour Eiffel & Quartier
  {
    id: 'cluster_cm_tour_eiffel',
    name: 'Restaurant près Tour Eiffel',
    language: 'fr',
    priority: 'medium',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_te_1',
        language: 'fr',
        query: 'restaurant près tour eiffel',
        intent: 'commercial',
        volume: 8900,
        kd: 85,
        serpFeatures: ['Local Pack', 'Images', 'Reviews'],
        opportunity: 78,
        cluster: 'Restaurant près Tour Eiffel',
        notes: 'Très compétitif mais volume énorme'
      },
      {
        id: 'kw_cm_te_2',
        language: 'fr',
        query: 'bistrot tour eiffel',
        intent: 'commercial',
        volume: 1200,
        kd: 75,
        serpFeatures: ['Local Pack'],
        opportunity: 82,
        cluster: 'Restaurant près Tour Eiffel'
      },
      {
        id: 'kw_cm_te_3',
        language: 'fr',
        query: 'restaurant ecole militaire',
        intent: 'commercial',
        volume: 820,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Restaurant près Tour Eiffel'
      },
      {
        id: 'kw_cm_te_4',
        language: 'fr',
        query: 'où manger tour eiffel',
        intent: 'commercial',
        volume: 3200,
        kd: 78,
        serpFeatures: ['Featured Snippet', 'Local Pack'],
        opportunity: 80,
        cluster: 'Restaurant près Tour Eiffel'
      },
      {
        id: 'kw_cm_te_5',
        language: 'fr',
        query: 'restaurant champ de mars',
        intent: 'commercial',
        volume: 1500,
        kd: 70,
        serpFeatures: ['Local Pack'],
        opportunity: 84,
        cluster: 'Restaurant près Tour Eiffel'
      }
    ]
  },
  // Cluster 8 : Long-tail Spécifiques
  {
    id: 'cluster_cm_longtail',
    name: 'Long-tail & Questions',
    language: 'fr',
    priority: 'low',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_lt_1',
        language: 'fr',
        query: 'meilleur bistrot invalides',
        intent: 'commercial',
        volume: 180,
        kd: 45,
        serpFeatures: ['Featured Snippet'],
        opportunity: 90,
        cluster: 'Long-tail & Questions'
      },
      {
        id: 'kw_cm_lt_2',
        language: 'fr',
        query: 'bistrot pas cher invalides',
        intent: 'transactional',
        volume: 220,
        kd: 42,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Long-tail & Questions'
      },
      {
        id: 'kw_cm_lt_3',
        language: 'fr',
        query: 'restaurant groupe invalides',
        intent: 'transactional',
        volume: 150,
        kd: 38,
        serpFeatures: [],
        opportunity: 85,
        cluster: 'Long-tail & Questions'
      },
      {
        id: 'kw_cm_lt_4',
        language: 'fr',
        query: 'privatiser restaurant paris 7',
        intent: 'transactional',
        volume: 280,
        kd: 48,
        serpFeatures: [],
        opportunity: 87,
        cluster: 'Long-tail & Questions'
      },
      {
        id: 'kw_cm_lt_5',
        language: 'fr',
        query: 'restaurant ouvert dimanche invalides',
        intent: 'transactional',
        volume: 120,
        kd: 35,
        serpFeatures: ['Featured Snippet'],
        opportunity: 82,
        cluster: 'Long-tail & Questions',
        notes: 'Café Max fermé le weekend - ne pas cibler'
      }
    ]
  },
  // Cluster 9 : EN - International Tourists
  {
    id: 'cluster_cm_en_1',
    name: 'Traditional French Restaurant Paris',
    language: 'en',
    priority: 'medium',
    status: 'to_do',
    assignee: 'Content Team',
    keywords: [
      {
        id: 'kw_cm_en_1',
        language: 'en',
        query: 'traditional french restaurant paris',
        intent: 'commercial',
        volume: 8900,
        kd: 78,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 85,
        cluster: 'Traditional French Restaurant Paris',
        notes: 'Version EN mal positionnée (pos. 39)'
      },
      {
        id: 'kw_cm_en_2',
        language: 'en',
        query: 'bistro near eiffel tower',
        intent: 'commercial',
        volume: 5400,
        kd: 75,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 82,
        cluster: 'Traditional French Restaurant Paris'
      },
      {
        id: 'kw_cm_en_3',
        language: 'en',
        query: 'authentic parisian bistro',
        intent: 'commercial',
        volume: 3200,
        kd: 68,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Traditional French Restaurant Paris'
      },
      {
        id: 'kw_cm_en_4',
        language: 'en',
        query: 'restaurant invalides paris',
        intent: 'commercial',
        volume: 1800,
        kd: 65,
        serpFeatures: ['Local Pack'],
        opportunity: 90,
        cluster: 'Traditional French Restaurant Paris'
      },
      {
        id: 'kw_cm_en_5',
        language: 'en',
        query: 'french cuisine 7th arrondissement',
        intent: 'commercial',
        volume: 920,
        kd: 60,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Traditional French Restaurant Paris'
      },
      {
        id: 'kw_cm_en_6',
        language: 'en',
        query: 'where to eat near eiffel tower',
        intent: 'commercial',
        volume: 12000,
        kd: 82,
        serpFeatures: ['Featured Snippet', 'Local Pack'],
        opportunity: 75,
        cluster: 'Traditional French Restaurant Paris',
        notes: 'Très compétitif mais énorme volume'
      },
      {
        id: 'kw_cm_en_7',
        language: 'en',
        query: 'lunch near invalides',
        intent: 'transactional',
        volume: 680,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Traditional French Restaurant Paris'
      },
      {
        id: 'kw_cm_en_8',
        language: 'en',
        query: 'historic restaurant paris',
        intent: 'informational',
        volume: 1200,
        kd: 65,
        serpFeatures: ['Featured Snippet'],
        opportunity: 88,
        cluster: 'Traditional French Restaurant Paris',
        notes: 'Histoire résistance = angle unique'
      },
      {
        id: 'kw_cm_en_9',
        language: 'en',
        query: 'french bistro terrace paris',
        intent: 'commercial',
        volume: 890,
        kd: 62,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 86,
        cluster: 'Traditional French Restaurant Paris'
      },
      {
        id: 'kw_cm_en_10',
        language: 'en',
        query: 'business lunch paris 7th',
        intent: 'transactional',
        volume: 420,
        kd: 55,
        serpFeatures: ['Local Pack'],
        opportunity: 84,
        cluster: 'Traditional French Restaurant Paris'
      }
    ]
  },
  // Cluster 10 : ES - Touristes Hispanophones
  {
    id: 'cluster_cm_es_1',
    name: 'Restaurante Francés Tradicional París',
    language: 'es',
    priority: 'medium',
    status: 'to_do',
    assignee: 'Content Team ES',
    keywords: [
      {
        id: 'kw_cm_es_1',
        language: 'es',
        query: 'restaurante frances tradicional paris',
        intent: 'commercial',
        volume: 3200,
        kd: 70,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 90,
        cluster: 'Restaurante Francés Tradicional París',
        notes: 'PAS DE VERSION ES - Opportunité énorme'
      },
      {
        id: 'kw_cm_es_2',
        language: 'es',
        query: 'bistro cerca torre eiffel',
        intent: 'commercial',
        volume: 2800,
        kd: 68,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 88,
        cluster: 'Restaurante Francés Tradicional París'
      },
      {
        id: 'kw_cm_es_3',
        language: 'es',
        query: 'donde comer en paris',
        intent: 'commercial',
        volume: 8900,
        kd: 75,
        serpFeatures: ['Featured Snippet', 'Local Pack'],
        opportunity: 82,
        cluster: 'Restaurante Francés Tradicional París',
        notes: 'Volume énorme - Très compétitif'
      },
      {
        id: 'kw_cm_es_4',
        language: 'es',
        query: 'restaurante autentico paris',
        intent: 'commercial',
        volume: 1800,
        kd: 62,
        serpFeatures: ['Local Pack'],
        opportunity: 86,
        cluster: 'Restaurante Francés Tradicional París'
      },
      {
        id: 'kw_cm_es_5',
        language: 'es',
        query: 'bistro parisino',
        intent: 'commercial',
        volume: 1200,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Restaurante Francés Tradicional París'
      },
      {
        id: 'kw_cm_es_6',
        language: 'es',
        query: 'cocina francesa paris',
        intent: 'commercial',
        volume: 2100,
        kd: 65,
        serpFeatures: ['Local Pack'],
        opportunity: 87,
        cluster: 'Restaurante Francés Tradicional París'
      },
      {
        id: 'kw_cm_es_7',
        language: 'es',
        query: 'restaurante terraza paris',
        intent: 'commercial',
        volume: 980,
        kd: 60,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 84,
        cluster: 'Restaurante Francés Tradicional París'
      },
      {
        id: 'kw_cm_es_8',
        language: 'es',
        query: 'almuerzo paris invalidez',
        intent: 'transactional',
        volume: 420,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 83,
        cluster: 'Restaurante Francés Tradicional París'
      }
    ]
  },
  // Cluster 11 : PT - Touristes Lusophones
  {
    id: 'cluster_cm_pt_1',
    name: 'Restaurante Francês Tradicional Paris',
    language: 'pt',
    priority: 'low',
    status: 'to_do',
    assignee: 'Content Team PT',
    keywords: [
      {
        id: 'kw_cm_pt_1',
        language: 'pt',
        query: 'restaurante frances tradicional paris',
        intent: 'commercial',
        volume: 1800,
        kd: 65,
        serpFeatures: ['Local Pack', 'Reviews'],
        opportunity: 88,
        cluster: 'Restaurante Francês Tradicional Paris',
        notes: 'PAS DE VERSION PT - Marché brésilien important'
      },
      {
        id: 'kw_cm_pt_2',
        language: 'pt',
        query: 'bistrô perto torre eiffel',
        intent: 'commercial',
        volume: 1500,
        kd: 62,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 86,
        cluster: 'Restaurante Francês Tradicional Paris'
      },
      {
        id: 'kw_cm_pt_3',
        language: 'pt',
        query: 'onde comer em paris',
        intent: 'commercial',
        volume: 5400,
        kd: 72,
        serpFeatures: ['Featured Snippet', 'Local Pack'],
        opportunity: 80,
        cluster: 'Restaurante Francês Tradicional Paris',
        notes: 'Volume élevé - Brésil + Portugal'
      },
      {
        id: 'kw_cm_pt_4',
        language: 'pt',
        query: 'restaurante autentico paris',
        intent: 'commercial',
        volume: 980,
        kd: 58,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Restaurante Francês Tradicional Paris'
      },
      {
        id: 'kw_cm_pt_5',
        language: 'pt',
        query: 'cozinha francesa paris',
        intent: 'commercial',
        volume: 1200,
        kd: 60,
        serpFeatures: ['Local Pack'],
        opportunity: 84,
        cluster: 'Restaurante Francês Tradicional Paris'
      },
      {
        id: 'kw_cm_pt_6',
        language: 'pt',
        query: 'restaurante terraco paris',
        intent: 'commercial',
        volume: 680,
        kd: 55,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 82,
        cluster: 'Restaurante Francês Tradicional Paris'
      },
      {
        id: 'kw_cm_pt_7',
        language: 'pt',
        query: 'almoco paris 7 arrondissement',
        intent: 'transactional',
        volume: 320,
        kd: 48,
        serpFeatures: ['Local Pack'],
        opportunity: 81,
        cluster: 'Restaurante Francês Tradicional Paris'
      }
    ]
  },
  // Cluster 12 : EN - Lunch & Business
  {
    id: 'cluster_cm_en_2',
    name: 'Business Lunch & Meetings Paris',
    language: 'en',
    priority: 'high',
    status: 'to_do',
    assignee: 'Content Team EN',
    keywords: [
      {
        id: 'kw_cm_en_biz_1',
        language: 'en',
        query: 'business lunch paris 7th',
        intent: 'transactional',
        volume: 820,
        kd: 55,
        serpFeatures: ['Local Pack'],
        opportunity: 90,
        cluster: 'Business Lunch & Meetings Paris',
        notes: 'Cible cadres/ambassades quartier'
      },
      {
        id: 'kw_cm_en_biz_2',
        language: 'en',
        query: 'french bistro business lunch',
        intent: 'commercial',
        volume: 480,
        kd: 52,
        serpFeatures: ['Local Pack'],
        opportunity: 88,
        cluster: 'Business Lunch & Meetings Paris'
      },
      {
        id: 'kw_cm_en_biz_3',
        language: 'en',
        query: 'restaurant near invalides',
        intent: 'commercial',
        volume: 1200,
        kd: 60,
        serpFeatures: ['Local Pack'],
        opportunity: 89,
        cluster: 'Business Lunch & Meetings Paris'
      },
      {
        id: 'kw_cm_en_biz_4',
        language: 'en',
        query: 'french terrace restaurant paris',
        intent: 'commercial',
        volume: 720,
        kd: 58,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 86,
        cluster: 'Business Lunch & Meetings Paris'
      }
    ]
  },
  // Cluster 13 : EN - Historic & Unique
  {
    id: 'cluster_cm_en_3',
    name: 'Historic French Bistro',
    language: 'en',
    priority: 'medium',
    status: 'to_do',
    assignee: 'Content Team EN',
    keywords: [
      {
        id: 'kw_cm_en_hist_1',
        language: 'en',
        query: 'historic restaurant paris',
        intent: 'informational',
        volume: 1400,
        kd: 68,
        serpFeatures: ['Featured Snippet', 'Images'],
        opportunity: 92,
        cluster: 'Historic French Bistro',
        notes: 'STORY UNIQUE - Jean Moulin / Résistance'
      },
      {
        id: 'kw_cm_en_hist_2',
        language: 'en',
        query: 'french resistance restaurant',
        intent: 'informational',
        volume: 280,
        kd: 42,
        serpFeatures: ['Featured Snippet'],
        opportunity: 95,
        cluster: 'Historic French Bistro',
        notes: 'Niche unique - Aucun concurrent'
      },
      {
        id: 'kw_cm_en_hist_3',
        language: 'en',
        query: 'belle epoque bistro paris',
        intent: 'commercial',
        volume: 580,
        kd: 60,
        serpFeatures: ['Local Pack', 'Images'],
        opportunity: 87,
        cluster: 'Historic French Bistro'
      },
      {
        id: 'kw_cm_en_hist_4',
        language: 'en',
        query: 'authentic french bistro experience',
        intent: 'commercial',
        volume: 920,
        kd: 65,
        serpFeatures: ['Local Pack'],
        opportunity: 85,
        cluster: 'Historic French Bistro'
      }
    ]
  }
];

export const getKeywordsByRestaurant = (restaurantId: string): KeywordCluster[] => {
  return restaurantId === '39v' ? keywords39V : keywordsCafeMax;
};

export const getKeywordsByLanguage = (restaurantId: string, language: 'fr' | 'en' | 'es' | 'pt'): KeywordCluster[] => {
  const allKeywords = getKeywordsByRestaurant(restaurantId);
  return allKeywords.filter(cluster => cluster.language === language);
};

export const getKeywordsByPriority = (restaurantId: string, priority: 'high' | 'medium' | 'low'): KeywordCluster[] => {
  const allKeywords = getKeywordsByRestaurant(restaurantId);
  return allKeywords.filter(cluster => cluster.priority === priority);
};

export const getKeywordStats = (restaurantId: string) => {
  const allKeywords = getKeywordsByRestaurant(restaurantId);
  const allKeywordsFlat = allKeywords.flatMap(cluster => cluster.keywords);

  return {
    totalKeywords: allKeywordsFlat.length,
    totalVolume: allKeywordsFlat.reduce((sum, kw) => sum + kw.volume, 0),
    avgKD: Math.round(allKeywordsFlat.reduce((sum, kw) => sum + kw.kd, 0) / allKeywordsFlat.length),
    avgOpportunity: Math.round(allKeywordsFlat.reduce((sum, kw) => sum + kw.opportunity, 0) / allKeywordsFlat.length),
    byLanguage: {
      fr: allKeywordsFlat.filter(kw => kw.language === 'fr').length,
      en: allKeywordsFlat.filter(kw => kw.language === 'en').length,
      es: allKeywordsFlat.filter(kw => kw.language === 'es').length,
      pt: allKeywordsFlat.filter(kw => kw.language === 'pt').length
    }
  };
};
